import React from 'react';
import { bool, func, number, shape } from 'prop-types';

import { PopUpCenterV2 } from 'Component/PopUp';
import { Button } from '@ajaibid/components';
import { noop } from '@ajaibid/utils';

import useEventTracker from '../tracker';
import { styPopupDeleteBtn, styPopupDeleteText } from './style';

const PopupDelete = ({ id, index, data, isModalDelete, setIsModalDelete, removeMfAutoOrder }) => {
  const dataIndex = data[index];

  const { eventClickDeleteMFAutoOrder } = useEventTracker();

  return (
    <PopUpCenterV2
      show={isModalDelete}
      title="Hapus Auto Beli?"
      onHide={() => setIsModalDelete(false)}
      width="628px"
    >
      <div className={styPopupDeleteText}>
        Dengan menghapus Auto Beli Reksa Dana. Transaksi di bulan berikutknya akan dibatalkan.
      </div>
      <div className={styPopupDeleteBtn}>
        <Button variant="naked" onClick={() => setIsModalDelete(false)}>
          Batal
        </Button>
        <Button
          onClick={() => {
            removeMfAutoOrder(id);
            eventClickDeleteMFAutoOrder({
              fund_id: dataIndex.fund_id,
              total: dataIndex.amount,
              duration: dataIndex.frequency,
              page_name: 'MF Buy Page',
              instrument: 'MF',
              fund_name: dataIndex.name,
              autobuy_start: dataIndex.start_duration,
              autobuy_end: dataIndex.end_duration,
            });
          }}
        >
          Hapus
        </Button>
      </div>
    </PopUpCenterV2>
  );
};

PopupDelete.propTypes = {
  id: number,
  index: number,
  data: shape({}),
  isModalDelete: bool,
  setIsModalDelete: func,
  removeMfAutoOrder: func,
};

PopupDelete.defaultProps = {
  id: 0,
  index: 0,
  data: {},
  isModalDelete: false,
  setIsModalDelete: noop,
  removeMfAutoOrder: noop,
};

export default PopupDelete;
